import { DefaultHeader } from "../parts/Parts";


export const PageNotFound = () => {
    return (
        <>
            <DefaultHeader defaultHeader="404 - Page Not Found" />
            <div className="component page-not-found-component">
                <div className="row page-not-found-component--one">
                    <div className="col col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <p>The page was not found</p>
                    </div>
                </div>
            </div>
        </>
    );
}


export const PageNotAuthorized = () => {
    return (
        <>
            <DefaultHeader defaultHeader="403 - Page Not Authorized" />
            <div className="component page-not-authorized-component">
                <div className="row page-not-authorized-component--one">
                    <div className="col col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <p>This page is not authorized</p>
                    </div>
                </div>
            </div>
        </>
    );
}